export const SEARCH_PRODUCT_NUMBER = '@abs:SEARCH_PRODUCT_NUMBER';
export const SEARCH_PRODUCT_NUMBER_SUCCESS =
	'@abs:SEARCH_PRODUCT_NUMBER_SUCCESS';
export const SEARCH_PRODUCT_NUMBER_ERROR = '@abs:SEARCH_PRODUCT_NUMBER_ERROR';

export const RESET_PRODUCT_VALIDATION_AND_LOOKUP =
	'@abs:RESET_PRODUCT_VALIDATION_AND_LOOKUP';
